module.exports = __webpack_public_path__ + "img/that-picture-4.4f0945b3.png";